import React, { useEffect, useRef, useState } from "react";

function formatTime(seconds) {
  if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
}

function RecordingMessage({ src }) {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    setPlaying(false);
    setDuration(0);
    setCurrent(0);
  }, [src]);

  if (!src) return null;

  const progress = duration > 0 ? (current / duration) * 100 : 0;

  const togglePlay = async () => {
    const audio = audioRef.current;
    if (!audio) return;
    try {
      if (audio.paused) {
        await audio.play();
        setPlaying(true);
      } else {
        audio.pause();
        setPlaying(false);
      }
    } catch (e) {
      console.error(e);
      setPlaying(false);
    }
  };

  return (
    <div className="voice-message-wrap">
      <audio
        ref={audioRef}
        src={"" + src}
        preload="metadata"
        onLoadedMetadata={(e) => setDuration(e.target.duration || 0)}
        onTimeUpdate={(e) => setCurrent(e.target.currentTime || 0)}
        onEnded={() => {
          setPlaying(false);
          setCurrent(0);
        }}
        onPause={() => setPlaying(false)}
        onPlay={() => setPlaying(true)}
      />
      <button
        type="button"
        className="voice-message-play"
        onClick={togglePlay}
        aria-label={playing ? "Pause voice message" : "Play voice message"}
      >
        {playing ? (
          <span className="voice-message-pause-icon" />
        ) : (
          <span className="voice-message-play-icon" />
        )}
      </button>
      <div className="voice-message-body">
        <div className="voice-message-wave" aria-hidden="true">
          {Array.from({ length: 24 }).map((_, i) => (
            <span
              key={i}
              className={`voice-message-bar ${playing ? "is-playing" : ""}`}
              style={{
                height: `${10 + ((i * 7) % 16)}px`,
                animationDelay: `${i * 0.04}s`,
              }}
            />
          ))}
        </div>
        <div className="voice-message-progress-track">
          <div
            className="voice-message-progress-fill"
            style={{ width: `${progress}%` }}
          />
        </div>
        <div className="voice-message-meta">
          <span>{formatTime(current)}</span>
          <span>{formatTime(duration)}</span>
        </div>
      </div>
    </div>
  );
}

export default RecordingMessage;
